export enum ActivePage {
    DASHBOARD = "Dashboard",
    ANALYTICS = "Analytics",
    HEATMAP = "Heatmap",
    SETTINGS = "Settings"
}
